import type { Capability, PaginatedResponse } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'

export interface CapabilitiesQuery {
  page?: number
  pageSize?: number
  domainId?: number
  parentCapabilityId?: number
  level?: 1 | 2
  includeInactive?: boolean
  q?: string
  asOf?: string
}

/**
 * Fetches GET /api/capabilities. Filters are reflected in the URL so
 * navigating away and back re-uses the same path-keyed cache miss/hit.
 */
export function useCapabilities(
  query: CapabilitiesQuery,
): QueryState<PaginatedResponse<Capability>> {
  return useApiQuery<PaginatedResponse<Capability>>(buildPath(query))
}

function buildPath(q: CapabilitiesQuery): string {
  const params = new URLSearchParams()
  if (q.page !== undefined) params.set('page', String(q.page))
  if (q.pageSize !== undefined) params.set('pageSize', String(q.pageSize))
  if (q.domainId !== undefined) params.set('domainId', String(q.domainId))
  if (q.parentCapabilityId !== undefined) {
    params.set('parentCapabilityId', String(q.parentCapabilityId))
  }
  if (q.level !== undefined) params.set('level', String(q.level))
  if (q.includeInactive) params.set('includeInactive', 'true')
  if (q.q) params.set('q', q.q)
  if (q.asOf) params.set('asOf', q.asOf)
  const qs = params.toString()
  return qs ? `/api/capabilities?${qs}` : '/api/capabilities'
}
